export default __webpack_public_path__ + "static/media/Fresnel_Web.2c0d75d5.jpg";